module.exports = __webpack_public_path__ + "static/media/everience-logo.d5b39654.png";